export default defineNuxtRouteMiddleware(() => {
  const host = useRequestHeader('host') ?? globalThis.location?.host;

  if (host?.startsWith('www.')) {
    const url = useRequestURL();
    url.host = url.host.slice(4);

    return navigateTo(url.href, { external: true, redirectCode: 301 });
  }
});
